import type { RunStatus } from '../api/types'
import { cn } from '../lib/cn'

/** Bar colour per run status — same scale as the badge, one step quieter for neutral states. */
const BAR: Record<RunStatus, string> = {
  succeeded: 'bg-mint-500',
  failed: 'bg-red-600',
  'waiting-approval': 'bg-amber-400',
  running: 'bg-ginger-500',
  queued: 'bg-ginger-300',
  cancelled: 'bg-cream-400',
  skipped: 'bg-cream-300'
}

const SLOTS = 10

/**
 * The last ten runs of a routine as ten bars, oldest on the left. Read as "is this thing getting
 * worse?" without opening anything; the newest run sits on the right edge so a fresh failure is
 * always in the same place (docs/web-ui.md §3).
 */
export function RunSpark({ runs, label, className }: { runs: { status: RunStatus }[]; label: string; className?: string }) {
  const shown = runs.slice(-SLOTS)
  const empty = SLOTS - shown.length
  return (
    <span className={cn('flex items-end gap-[2px]', className)} role="img" aria-label={label} title={label}>
      {Array.from({ length: SLOTS }, (_, i) => (
        <span
          key={i}
          className={cn('h-[18px] w-[5px] rounded-[1px]', i < empty ? 'bg-transparent' : BAR[shown[i - empty].status])}
        />
      ))}
    </span>
  )
}
